import React from 'react'
import PropTypes from 'prop-types'

import "../styles/main.scss"

const TemplateWrapper = ({ children }) => (<div>{children()}</div>)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js